<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    ATAS DIREX
                </span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    :itens="atasdirexLista"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <Cad-Ata-Direx
                                @listarAtas="listar()"
                                :modoCadastro="true"
                                :AtaDirexPai=null
                            >
                            </Cad-Ata-Direx>
                        </b-button-group>


                        <!--
                        <b-button-group class="float-right">
                            <Encaminhar-Processos
                                @click="encaminhar(data.idAtaDirex)"
                            >
                            </Encaminhar-Processos>
                        </b-button-group>
                        -->
                    </template>

                    <template slot="dtReuniao" slot-scope="data">
                        {{
                            data.dtReuniao
                                ? $moment(data.dtReuniao).format(
                                      'DD/MM/YYYY'
                                  )
                                : ''
                        }}
                    </template>
                    <template slot="dtCadastro" slot-scope="data">
                        {{
                            data.dtReuniao
                                ? $moment(data.dtCadastro).format(
                                      'DD/MM/YYYY HH:mm:ss'
                                  )
                                : ''
                        }}
                    </template>
                    <template slot="situacaoAta" slot-scope="data">
                        <app-status
                            :status="data.situacaoAta.toUpperCase()"
                        ></app-status>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-danger float-left mr-1">
                            <i
                                class="fa fa-times-circle fa-lg icon-button"
                                title="Cancelar Ata"
                                v-if="$temAcessoView('ATADIREX-08') && data.nuSituacaoAta==1"
                                @click.stop="permiteCancelarAta(data)"
                            ></i>
                        </span>
                        <span class="text-warning float-left mr-1">
                            <Encaminhar-Processos
                                :ataDirex="data"
                                @listarAtas="listar()"
                                v-if="$temAcessoView('ATADIREX-06') && data.nuSituacaoAta!=2 && data.quantidadeProcessos>0"
                            >
                            </Encaminhar-Processos>
                        </span>

                        <span class="text-primary float-left mr-1">
                           <Cad-Ata-Direx
                                v-if="$temAcessoView('ATADIREX-02') && (data.nuSituacaoAta==1)"
                                @listarAtas="listar()"
                                :modoCadastro="false"
                                :AtaDirexPai="data"
                            >
                            </Cad-Ata-Direx>
                        </span>

                        <span class="text-success float-left mr-1">
                            <i
                                class="fa fa-check-circle fa-lg icon-button"
                                title="Concluir Ata"
                                v-if="$temAcessoView('ATADIREX-09') && (data.nuSituacaoAta==1)"
                                @click.stop="confirmarConcluirAta(data)"
                            ></i>
                        </span>

                        <span class="text-danger float-left mr-1">
                            <i
                                class="fa fa-repeat fa-lg icon-button"
                                title="Reabrir Ata"
                                v-if="$temAcessoView('ATADIREX-10') && (data.nuSituacaoAta==3)"
                                @click.stop="confirmarReabrirAta(data)"
                            ></i>
                        </span>

                        <span class="text-primary float-left mr-1">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhes"
                                v-if="$temAcessoView('ATADIREX-11')"
                                @click.stop="detalhar(data)"
                            ></i>
                        </span>

                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <!--router-view :convenio="convenio"></router-view -->
    </div>
</template>


<script>
import AtaDirexServicos from './AtaDirexServicos'
import CadAtaDirex from './cadastro/CadAtaDirex.vue'
import EncaminharProcessos from './EncaminharProcessosAtaDirex.vue'

//import AtaDirexDetalhar from './detalhes/AtaDirexDetalhar.vue'

export default {
    components:{
        CadAtaDirex,
        EncaminharProcessos
        //AtaDirexDetalhar
    },

    data() {
        return {
            ataCancelada:false,
            atasdirexLista:[],
            itensPorPagina: 5,
            campos: [
                {
                    key: 'nuAtaDirex',
                    label: 'Ata Direx',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dtReuniao',
                    label: 'Data da Reunião',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'tipoAta',
                    label: 'Tipo da Ata Direx',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'processosEncaminhados',
                    label: 'Processos Encaminhados',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'quantidadeProcessos',
                    label: 'Qtd. de Processos',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dtCadastro',
                    label: 'Data de Cadastro',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'usrLogin',
                    label: 'Resp. Cadastro',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'situacaoAta',
                    label: 'Situação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                },
            ]
        }
    },

    methods: {
        listar(){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ListarAtasDirex().then(response => {
                if (response) {
                    if (response.success) {
                        this.atasdirexLista = response.data
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        permiteCancelarAta(data){
            if (data.quantidadeProcessos<=0 || !data.processosVinculados){
                this.confirmarCancelarAta(data)
            }else{
                this.$swal({
                    title: 'Atenção',
                    html: `Esta Ata Direx não pode ser cancelada, pois já possui processo(s) vinculado(s) a Contrato(s) ou Convênio(s)
                    <br/><br/>`,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK',
                })
            }
        },

        confirmarCancelarAta(data) {
            if (data.quantidadeProcessos>0){
                this.$swal({
                    title: 'Atenção',
                    html: `Ao confirmar o cancelamento desta Ata Direx, todos os processo vinculados também serão cancelados. Deseja continuar mesmo assim?
                    <br/><br/>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.$swal({
                            title: 'Cancelar Ata Direx',
                            html: `Confirma o cancelamento da Ata Direx <b>${data.nuAtaDirex}</b>?
                            <br/><br/>`,
                            icon: 'question',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Sim',
                            cancelButtonText: 'Não'
                        }).then(result => {
                            if (result.value) {
                                this.cancelarAta(data)
                            }
                        })
                    }
                })
            }else{
                this.$swal({
                    title: 'Cancelar Ata Direx',
                    html: `Confirma o cancelamento da Ata Direx <b>${data.nuAtaDirex}</b>?
                    <br/><br/>`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.cancelarAta(data)
                    }
                })
            }
        },

        cancelarAta(data){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.CancelarAtaDirex(data).then(response => {
                if (response) {
                    if (response.success) {
                        this.listar()
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarConcluirAta(data) {
            this.$swal({
                title: 'Concluir Ata Direx',
                html: `Confirma a conclusão da Ata Direx <b>${data.nuAtaDirex}</b>?
                <br/><br/>`,
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.concluirAta(data)
                }
            })
        },

        concluirAta(data){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ConcluirAtaDirex(data).then(response => {
                if (response) {
                    if (response.success) {
                        this.listar()
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarReabrirAta(data) {
            this.$swal({
                title: 'Reabrir Ata Direx',
                html: `Confirma a reabertura da Ata Direx <b>${data.nuAtaDirex}</b>?
                <br/><br/>`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.reabrirAta(data)
                }
            })
        },

        reabrirAta(data){
            this.$store.dispatch('addRequest')
            AtaDirexServicos.ReabrirAtaDirex(data).then(response => {
                if (response) {
                    if (response.success) {
                        this.listar()
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalhar(data){
            this.$router.push({
                name: 'AtaDirexDetalhes',
                params: {
                    idAtaDirex: data.idAtaDirex,
                    tabindex:0,
                    mostrarModal: false,
                    nuSituacaoAta: parseInt(data.nuSituacaoAta)
                }
            })
        },
    },

    created() {
        this.listar()
    },
}
</script>

